import * as launchDarklyClient from 'launchdarkly-js-client-sdk';
import type { LDClient as LDClientInterface } from 'launchdarkly-js-client-sdk';
import { createContext, PropsWithChildren } from 'react';

const clientId = import.meta.env.ARCADIA_LD_CLIENT_ID;

export const LDContext = createContext<LDClientInterface | null>(null);

export const LDClient = clientId
  ? launchDarklyClient.initialize(clientId, { kind: 'user', anonymous: true })
  : null;

// Thin context provider — does not block rendering. Children render immediately
// with safe flag defaults; useLDFlag resolves values asynchronously.
export const LDProvider = ({
  children,
  client = LDClient,
}: PropsWithChildren<{ client?: LDClientInterface | null }>) => (
  <LDContext.Provider value={client}>{children}</LDContext.Provider>
);
